export default __webpack_public_path__ + "static/media/reading.c5e94f7466987888612d11cf0a678829.png";